import React from "react";
import logo from "../../img/stackline-logo.png";

const Header = props => {
  return (
    <div id="header">
      <img src={logo} alt="Stackline logo" />
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/js/components/Header.js